import { render, staticRenderFns } from "./UserDataForm.vue?vue&type=template&id=1b8924e2&scoped=true"
import script from "./UserDataForm.vue?vue&type=script&lang=js"
export * from "./UserDataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8924e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b8924e2')) {
      api.createRecord('1b8924e2', component.options)
    } else {
      api.reload('1b8924e2', component.options)
    }
    module.hot.accept("./UserDataForm.vue?vue&type=template&id=1b8924e2&scoped=true", function () {
      api.rerender('1b8924e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/UserDataForm.vue"
export default component.exports